import { render, staticRenderFns } from "./UnnoPop.vue?vue&type=template&id=199512d9&scoped=true"
import script from "./UnnoPop.vue?vue&type=script&lang=js"
export * from "./UnnoPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199512d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199512d9')) {
      api.createRecord('199512d9', component.options)
    } else {
      api.reload('199512d9', component.options)
    }
    module.hot.accept("./UnnoPop.vue?vue&type=template&id=199512d9&scoped=true", function () {
      api.rerender('199512d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/UnnoPop.vue"
export default component.exports